import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'pcln-design-system'
import { ArrowUp, ArrowDown, ArrowRight, ArrowLeft } from 'pcln-icons'
import styled from 'styled-components'

const RoundButton = styled(Button)`
  height: 40px;
  width: 40px;

  &&& {
    border-radius: 50%;
    padding: 8px 0;
  }
`

const iconLookup = {
  up: ArrowUp,
  down: ArrowDown,
  left: ArrowLeft,
  right: ArrowRight
}

const ArrowButton = props => {
  const IconDirection = iconLookup[props.direction] || ArrowLeft
  return (
    <RoundButton
      {...props}
      disabled={props.disabled}
      onClick={props.onClick}
      data-testid={`arrow${props.direction}`}
    >
      <IconDirection />
    </RoundButton>
  )
}

ArrowButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  direction: PropTypes.string
}

export default ArrowButton
